import { useMemo } from 'react';
import { MdContentCopy } from 'react-icons/md';
import { copyToClipboard } from '../../helpers/utils';
import { GoPerson } from 'react-icons/go';

const SettingsUserProfile = () => {
  const currentUser = useMemo(
    () => ({
      firstName: localStorage.getItem('first_name'),
      lastName: localStorage.getItem('last_name'),
      email: localStorage.getItem('email'),
      userId: localStorage.getItem('user_id'),
    }),
    [],
  );

  return (
    <div className="settings-section">
      <div className="user-info">
        <div className="avatar">
          <GoPerson />
        </div>
        <div className="details">
          <span className="details-name">
            {currentUser.firstName} {currentUser.lastName}
          </span>
          <div className="details-entails">
            <span className="details-id" onClick={() => copyToClipboard('User ID', currentUser.userId || '')}>
              User ID: {currentUser.userId} <MdContentCopy />
            </span>
            <span className="details-email" onClick={() => copyToClipboard('Email', currentUser.email || '')}>
              Email: {currentUser.email} <MdContentCopy />
            </span>
          </div>
        </div>
      </div>

      <div className="settings-form">
        <div className="settings-form-item">
          <label htmlFor="name">Name</label>
          <input className="input" id="name" value={currentUser.firstName + ' ' + currentUser.lastName} readOnly />
        </div>
        <div className="settings-form-item">
          <label htmlFor="email">Email Address</label>
          <input className="input" id="email" value={currentUser.email || ''} readOnly />
        </div>
      </div>
    </div>
  );
};

export default SettingsUserProfile;
